
import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Utensils, Sun } from "lucide-react";
import { useIsMobile } from "@/hooks/use-mobile";
import { toast } from "sonner";

export const CookMode = () => {
  const [wakeLock, setWakeLock] = useState<WakeLockSentinel | null>(null);
  const [isSupported, setIsSupported] = useState(false);
  const isMobile = useIsMobile();

  useEffect(() => {
    // Check if the Wake Lock API is supported
    setIsSupported('wakeLock' in navigator);
  }, []);

  const enableCookMode = async () => {
    try {
      const wakeLock = await navigator.wakeLock.request('screen');
      setWakeLock(wakeLock);
      toast.success("Cook Mode enabled - screen will stay awake");

      wakeLock.addEventListener('release', () => {
        setWakeLock(null);
        toast.info("Cook Mode disabled");
      });
    } catch (err) {
      console.error('Failed to enable Cook Mode:', err);
      toast.error("Failed to enable Cook Mode");
    }
  };

  const disableCookMode = () => {
    if (wakeLock) {
      wakeLock.release();
      setWakeLock(null);
      toast.success("Cook Mode disabled");
    }
  };

  if (!isSupported || !isMobile) {
    return null;
  }

  return (
    <Button
      variant={wakeLock ? "default" : "outline"}
      size="sm"
      onClick={wakeLock ? disableCookMode : enableCookMode}
      className="flex items-center gap-2"
    >
      {isMobile ? (
        <Sun className="w-4 h-4" />
      ) : (
        <Utensils className="w-4 h-4" />
      )}
      <span className="md:inline hidden">
        {wakeLock ? "Exit" : "Cook Mode"}
      </span>
    </Button>
  );
};

export default CookMode;
